/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Header from "../../Common/Navbar";
import Pagination from "../../ListingPage/Pagination";
import { Link } from "react-router-dom";
import { fetchApi } from "../../utlis/axios";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import Loader from "../../animation/Loader.json";
import { FaSearch, FaFilter, FaChevronDown, FaChevronLeft } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { LuFilter } from "react-icons/lu";
import { FamilyRegistration } from "../../RegistrationForms/FamilyRegistration";

export const DetailPage = () => {
  const [familyData, setFamilyData] = useState([]);
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedToggle, setSelectedToggle] = useState("accepted");
  const [isLoading, setIsLoading] = useState(null);
  const [isOpen, setIsOpen]=useState(false)
  const [selectedStatus, setSelectedStatus] = useState({
    "in-review": false,
    accepted: false,
    hold: false,
    rejected: false,
  });
  const [selectedPriority, setSelectedPriority] = useState({
    high: false,
    low: false,
    normal: false,
  });
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();

  const getFamilyData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`family/?search=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setFamilyData(result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  useEffect(() => {
    getFamilyData();
  }, [searchQuery, access, selectedToggle]);

  const handleTableRowClick = (id) => {
    navigate(`/familylistingdetail/${id}`);
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(familyData.count / itemsPerPage);

  const fetchDataForPage = async (pageNumber) => {
    const newOffset = (pageNumber - 1) * itemsPerPage;
    try {
      const selectedStatusList = Object.keys(selectedStatus).filter(
        (status) => selectedStatus[status]
      );

      const selectedPriorityList = Object.keys(selectedPriority).filter(
        (priority) => selectedPriority[priority]
      );

      const result = await fetchApi.get(
        `family/?limit=${itemsPerPage}&offset=${newOffset}&page=${pageNumber}&pageSize=${itemsPerPage}&search=${searchQuery}&status=${selectedStatusList.join(
          ","
        )}&application_priority=${selectedPriorityList.join(",")}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );

      return result;
    } catch (error) {
      throw error;
    }
  };

  const handlePageClick = (pageNumber) => {
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      setIsLoading(true);

      fetchDataForPage(pageNumber)
        .then((result) => {
          if (result.status === 200) {
            setFamilyData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };


  const handleToggleClick = (toggleName) => {
    setSelectedToggle(toggleName);
  };

  const handleCheckboxChange = (status) => {
    const updatedStatus = {
      ...selectedStatus,
      [status]: !selectedStatus[status],
    };
    setSelectedStatus(updatedStatus);
  };

  useEffect(() => {
    if (Object.values(selectedStatus).some((value) => value)) {
      setIsLoading(true);
      fetchDataForPage(currentPage)
        .then((result) => {
          if (result.status === 200) {
            setFamilyData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedStatus, currentPage]);

  const handlePriorityChange = (priority) => {
    const updatedPriority = {
      ...selectedPriority,
      [priority]: !selectedPriority[priority],
    };
    setSelectedPriority(updatedPriority);
  };

  useEffect(() => {
    if (Object.values(selectedPriority).some((value) => value)) {
      setIsLoading(true);

      fetchDataForPage(currentPage)
        .then((result) => {
          if (result.status === 200) {
            setFamilyData(result?.data);
            console.log("fetchDataForPage", result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedPriority, currentPage]);

  const getActiveFilterCount = () => {
    const statusCount = Object.values(selectedStatus).filter(Boolean).length;
    const priorityCount = Object.values(selectedPriority).filter(Boolean).length;
    return statusCount + priorityCount;
  };

  // Handle click outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowFilterDropdown(false);
      }
    };

    // Add event listener when dropdown is open
    if (showFilterDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterDropdown]);

  return (
    <>
      <Header parent={'family'}/>
      <button className="w-max p-1 mt-24 sm:ml-[32px] ml-[16px] rounded-full shadow-none bg-primary-green text-white mb-4 " onClick={()=>navigate(-1)}>
<FaChevronLeft size={24}/>
</button>
      <div className="w-full px-[16px] md:px-10 min-h-screen sm:mt-6 mt-[16px] max-w-screen-xl mx-auto">
        {/* Top Section */}
        <div className="flex sm:items-center items-end sm:flex-row flex-col justify-between gap-3 mt-6 md:mb-8 mb-3">
          
        <div className="flex items-center gap-2 sm:w-max w-full ">
          {/* Search */}
          <div className="relative flex justify-center border rounded-full sm:py-2 py-[4px] px-2 sm:w-[400px] w-full bg-[#FCFBF7] items-center gap-2">
            <FaSearch className="text-gray sm:w-6 sm:h-6 w-[16px] h-[16px]" />
            <input
              type="search"
              name="search"
              className="w-full outline-none text-gray-600 py-1 px-1 bg-transparent"
              placeholder="Search here...."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
            {/* Filter Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                className="flex items-center gap-2 sm:p-2.5 p-[4px] bg-transparent shadow-none rounded-xl hover:bg-gray-50 transition-colors" style={{border:'2px solid #d8d8d8'}}
                onClick={() => setShowFilterDropdown(!showFilterDropdown)}
              >
                <LuFilter size={24} className="text-black" />
              </button>

              {/* Filter Dropdown Content */}
              {showFilterDropdown && (
                <div className="absolute top-full sm:left-0 right-[0] mt-2 w-80 bg-white border-[2px] border-[#d8d8d8] rounded-2xl shadow-lg z-10 p-6">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
                    <button
                      onClick={() => setShowFilterDropdown(false)}
                      className="w-max bg-[#d8d8d8] p-1 rounded-full"
                    >
                      <IoMdClose size={20} className="text-black" />
                    </button>
                  </div>

                  {/* Family Status Filters */}
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Family Status</h4>
                    <div className="grid grid-cols-2 gap-3">
                      {Object.keys(selectedStatus).map((status) => (
                        <label key={status} className="flex items-center gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedStatus[status]}
                            onChange={() => handleCheckboxChange(status)}
                            className="w-4 h-4 text-primary-green border-gray-300 rounded focus:ring-primary-green"
                          />
                          <span className="text-sm text-gray-700 capitalize">
                            {status === "in-review" ? "In Review" : status}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Application Priority Filters */}
                  <div className="mb-4">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Application Priority</h4>
                    <div className="grid grid-cols-2 gap-3">
                      {Object.keys(selectedPriority).map((priority) => (
                        <label key={priority} className="flex items-center gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedPriority[priority]}
                            onChange={() => handlePriorityChange(priority)}
                            className="w-4 h-4 text-primary-green border-gray-300 rounded focus:ring-primary-green"
                          />
                          <span className="text-sm text-gray-700 capitalize">{priority}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
            </div>

          

            {/* Register Family Button */}
              <button className="primary-button sm:text-base text-sm font-medium " onClick={()=>setIsOpen(true)}>
                Register Family
              </button>
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto bg-white rounded-[20px] border border-gray-border">
          
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="bg-primary-green text-white text-left">
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Name
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Application Priority
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Status
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Registered Date
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Status Statement
                </th>
              </tr>
            </thead>

            <tbody className="font-mulish">
              {isLoading ? (
                <tr>
                  <td colSpan={5} className="h-[60vh]">
                    <div className="flex justify-center items-center h-full w-full">
                      <Lottie
                        loop={true}
                        animationData={Loader}
                        style={{ width: "200px" }}
                        className="auth-sidebar-video"
                      />
                    </div>
                  </td>
                </tr>
              ) : familyData?.results?.length > 0 ? (
                familyData?.results?.map((data, index) => (
                  <tr
                    key={index}
                    className={`cursor-pointer ${
                      index % 2 === 0 ? "bg-white" : "bg-[#219D8014]"
                    } hover:bg-gray-200`}
                    onClick={() => handleTableRowClick(data?.id)}
                  >
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      {data?.name}
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate capitalize">
                      {data?.application_priority}
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate capitalize">{data?.status}
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      {moment
                        .utc(data?.updated_at?.toString())
                        .format("MM/DD/YYYY")}
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate ">
                      {data?.status_statement && data.status_statement.length > 30
                        ? `${data.status_statement.slice(0, 30)}...`
                        : data?.status_statement}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="p-4 text-center">
                    No families found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

       {/* Pagination */}
       <div className="flex justify-center items-center mt-6">
            <Pagination
              currentPage={currentPage}
              handlePageClick={handlePageClick}
              totalPages={totalPages}
            />
          </div>
      </div>
      {
        isOpen && <FamilyRegistration setShowModal={setIsOpen}/>
      }
    </>
  );
};